module.exports = __webpack_public_path__ + "469ed3c083e0197a7e5efd698fbaae51.svg";